module.exports = __webpack_public_path__ + "img/MO1.17ad8d40.png";